import { Api } from 'utils';

class DocumentService {

	static get = async (params?: any) => Api.createResponse('client/documents',params);
	static save = async (params?: any) => Api.createResponse('client/documents/save',params);
	static delete = async (params?: any) => Api.createResponse('client/documents/delete',params);

}

export default DocumentService;